var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2169_3275)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.47667 0 0 4.4775 0 10C0 15.5225 4.47667 20 10 20C15.5225 20 20 15.5225 20 10C20 4.4775 15.5225 0 10 0ZM10.1167 15.8483C6.89333 15.8483 4.28333 13.2317 4.28333 10C4.28333 6.76833 6.89333 4.15167 10.1167 4.15167C11.6917 4.15167 13.0083 4.7325 14.0183 5.67583L12.3733 7.32417V7.32083C11.7608 6.73583 10.9842 6.43583 10.1167 6.43583C8.19167 6.43583 6.6275 8.06583 6.6275 9.99667C6.6275 11.9258 8.19167 13.5608 10.1167 13.5608C11.8633 13.5608 13.0517 12.5592 13.2967 11.1842H10.1167V8.90333H15.6042C15.6775 9.295 15.7167 9.70333 15.7167 10.1317C15.7167 13.4733 13.4858 15.8483 10.1167 15.8483Z",
    fill: "#A14538"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2169_3275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c9b66e814056035e1eadf88dcf871e9d.svg";
export { ForwardRef as ReactComponent };